import { useStaticQuery, graphql } from 'gatsby'

export function useDataSlogan() {
    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Quote" }, locale: { eq: "hy" }) {
                value
            }

            heroImage: datoCmsRenshinPageAbout(title: { eq: "Quote: Image" }, locale: { eq: "hy" }) {
                image: heroimage {
                    url
                }
            }
        }
    `)

    return data
}
